import React from "react";
import ReactPlayer from "react-player";

const VideoPlaylist = ({ videos }) => {
    if (!videos || videos.length === 0) {
        return <p>No videos available.</p>;
    }

    return (
        <div className="video-playlist">
            {videos.map((video, index) => (
                <div key={index} className="video-container my-4">
                    <ReactPlayer
                        url={video.url}
                        controls
                        width="100%"
                        height="100%"
                    />
                    <p className="text-center mt-2">{video.title}</p>
                </div>
            ))}
        </div>
    );
};

export default VideoPlaylist;
